<template>
  <!-- 合作伙伴模块 -->
  <div class="content-partner">
    <div class="top">
      <h3>{{ $t('partners') }}</h3>
      <div class="underline"></div>
    </div>
    <div v-for="partner in partnerList" :key="partner.id">
      <div class="partner-section">
        <!-- 渲染合作伙伴名称 -->
        <h4>{{ partner.name }}</h4>

        <ul class="partner-list">
          <!-- 遍历合作伙伴的子项 -->
          <li v-for="client in partner.children" :key="client.id">
            <!-- 渲染客户的image和名称 -->
            <img :src="client.image" :alt="client.name" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { listPartner } from "@/api/partner.js";
import { handleTree } from "@/utils/ruoyi.js";
export default {
  data() {
    return {
      partnerList: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      listPartner(null).then((response) => {
        this.partnerList = handleTree(response.data, "id", "parentId");
        console.log(this.partnerList);
      });
    },
  },
};
</script>



<style lang="scss" scoped>
//合作伙伴
.content-partner {
  padding: 60px 0;
  animation: moveUp 0.8s ease-out forwards;

  .partner-section {
    margin-top: 40px;

    h4 {
      font-size: 24px;
      color: #024190;
      margin-bottom: 20px;
      text-align: left;
      margin-left: 120px;
    }

    .partner-list {
      display: flex;
      flex-wrap: wrap;
      list-style: none;
      padding: 0;
      margin: 0 120px;

      li {
        flex: 0 0 20%; /* Adjust width */
        text-align: center;
        padding: 15px;
        box-sizing: border-box;

        img {
          max-width: 100%;
          height: auto;
          border: 1px solid #eaeaea;
          border-radius: 8px;
          transition: transform 0.3s;
        }

        img:hover {
          transform: scale(1.05);
        }
      }
    }
  }
}
</style>